import { render, staticRenderFns } from "./MerchantApps.vue?vue&type=template&id=5b869121"
import script from "./MerchantApps.vue?vue&type=script&lang=js"
export * from "./MerchantApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports